export const STORAGE_CUSTOMER_CREATED = "s0035";
export const STORAGE_CUSTOMER_CREATE_ERROR = "e0035";
export const STORAGE_CUSTOMER_UPDATED = "s0036";
export const STORAGE_CUSTOMER_UPDATE_ERROR = "e0036";
export const STORAGE_CUSTOMER_TURNED_ON = "s0037";
export const STORAGE_CUSTOMER_TURN_ON_ERROR = "e0037";
export const STORAGE_CUSTOMER_TURNED_OFF = "s0038";
export const STORAGE_CUSTOMER_TURN_OFF_ERROR = "e0038";
export const STORAGE_CUSTOMER_REMOVED = "s0039";
export const STORAGE_CUSTOMER_REMOVE_ERROR = "e0039";

export const customerStorage = {
  [STORAGE_CUSTOMER_CREATED]: {
    colorClass: "color_customer_storage",
    icon: "/img/users.svg",
    langKeyHistory: "notification.contract_entity.action",
    route: "contract.cabinet.customers.index",
    langKeyNotificationAction: "notification.contract_entity.action",
    langKeyNotificationTitle:
      "notification.contract_entity.customer_storage.title",
    routeParams: (data) => ({
      contractName: data.contractName
    }),
    langTextParams: (data, $t) => ({
      link: data.link,
      action: $t("notification.action.create"),
      entityType: $t("notification.contract.entity.customer.storage"),
      entityName: data.subjectName,
      user: data.initiatorName
    }),
    langTitleParams: (data) => ({
      name: data.subjectName
    }),
    hash: (id) => `#${id}`
  },
  [STORAGE_CUSTOMER_UPDATED]: {
    colorClass: "color_customer_storage",
    icon: "/img/users.svg",
    langKeyHistory: "notification.contract_entity.action",
    route: "contract.cabinet.customers.index",
    langKeyNotificationAction: "notification.contract_entity.action",
    langKeyNotificationTitle:
      "notification.contract_entity.customer_storage.title",
    routeParams: (data) => ({
      contractName: data.contractName
    }),
    langTextParams: (data, $t) => ({
      link: data.link,
      action: $t("notification.action.update"),
      entityType: $t("notification.contract.entity.customer.storage"),
      entityName: data.subjectName,
      user: data.initiatorName
    }),
    langTitleParams: (data) => ({
      name: data.subjectName
    }),
    hash: (id) => `#${id}`
  },
  [STORAGE_CUSTOMER_REMOVED]: {
    colorClass: "color_customer_storage",
    icon: "/img/users.svg",
    langKeyHistory: "notification.contract_entity.action",
    route: "contract.cabinet.customers.index",
    langKeyNotificationAction: "notification.contract_entity.action",
    langKeyNotificationTitle:
      "notification.contract_entity.customer_storage.title",
    routeParams: (data) => ({
      contractName: data.contractName
    }),
    langTextParams: (data, $t) => ({
      link: data.link,
      action: $t("notification.action.delete"),
      entityType: $t("notification.contract.entity.customer.storage"),
      entityName: data.subjectName,
      user: data.initiatorName
    }),
    langTitleParams: (data) => ({
      name: data.subjectName
    }),
    hash: (id) => `#${id}`
  },
  [STORAGE_CUSTOMER_TURNED_ON]: {
    colorClass: "color_customer_storage",
    icon: "/img/users.svg",
    langKeyHistory: "notification.contract_entity.action",
    route: "contract.cabinet.customers.index",
    langKeyNotificationAction: "notification.contract_entity.action",
    langKeyNotificationTitle:
      "notification.contract_entity.customer_storage.title",
    routeParams: (data) => ({
      contractName: data.contractName
    }),
    langTextParams: (data, $t) => ({
      link: data.link,
      action: $t("notification.action.turnOn"),
      entityType: $t("notification.contract.entity.customer.storage"),
      entityName: data.subjectName,
      user: data.initiatorName
    }),
    langTitleParams: (data) => ({
      name: data.subjectName
    }),
    hash: (id) => `#${id}`
  },
  [STORAGE_CUSTOMER_TURNED_OFF]: {
    colorClass: "color_customer_storage",
    icon: "/img/users.svg",
    langKeyHistory: "notification.contract_entity.action",
    route: "contract.cabinet.customers.index",
    langKeyNotificationAction: "notification.contract_entity.action",
    langKeyNotificationTitle:
      "notification.contract_entity.customer_storage.title",
    routeParams: (data) => ({
      contractName: data.contractName
    }),
    langTextParams: (data, $t) => ({
      link: data.link,
      action: $t("notification.action.turnOff"),
      entityType: $t("notification.contract.entity.customer.storage"),
      entityName: data.subjectName,
      user: data.initiatorName
    }),
    langTitleParams: (data) => ({
      name: data.subjectName
    }),
    hash: (id) => `#${id}`
  }
};
